/**
 * WPN GATEWAY ENTERPRISE WEB ADMIN API' dev
 *
 * API version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { CoreApiClientService } from 'pn-core-code';

import { apiBaseUrl } from '../api-base-url';
import { UserResponseDto } from '../model/userResponseDto';
import { ValidationError } from '../model/validationError';


@Injectable({
  providedIn: 'root',
})
export class MeService {

  constructor(
    protected api: CoreApiClientService) {
  }

  /**
   * [Authorize] type: http
   */
  public meGet$(): Observable<UserResponseDto> {
    return this.api.get(`${apiBaseUrl()}/me`, undefined);
  }
}
